<form class="dialog" [formGroup]="form" (submit)="submit()">
  <h2>Add Access Policy</h2>

  <app-radio-list
    [control]="authLevelControl"
    [display]="AuthLevelDisplay"
    [values]="AuthLevels"
    name="Authentication level"
  ></app-radio-list>

  @if (target === ConnectingTarget.Application) {
    @if (!applications) {
      <app-spinner>
        Loading applications...
      </app-spinner>
    } @else if (applications.length === 0) {
      <div>
        All available applications have been assigned to this access group already. You cannot assign any more.
      </div>
    } @else {
      <span>Application</span>
      <app-select-input
        [control]="applicationControl"
        [display]="ApplicationDisplay"
        [value]="ApplicationValue"
        [values]="applications"
      ></app-select-input>
      @if (filteredWarning) {
        <div class="filtered-warning">
          Some applications have already been assigned to this access group and aren't shown.
        </div>
      }
    }
  }

  @if (target === ConnectingTarget.AccessGroup) {
    <span>Access Group</span>
    @if (!accessGroups) {
      <app-spinner>
        Loading access groups...
      </app-spinner>
    } @else if (accessGroups.length === 0) {
      <div>
        All available access groups have been assigned to this application already. You cannot assign any more.
      </div>
    } @else {
      <app-select-input
        [control]="accessGroupControl"
        [display]="AccessGroupDisplay"
        [value]="AccessGroupValue"
        [values]="accessGroups"
      ></app-select-input>
      @if (filteredWarning) {
        <div class="filtered-warning">
          Some access groups have already been assigned to the application and aren't shown.
        </div>
      }
    }
  }

  @if (error) {
    <div class="error-container">
      <img alt="Alert" src="/assets/default/alert.svg">
      <div class="error-message">
        We can't create this access policy.

        @if (target === ConnectingTarget.AccessGroup) {
          <span>
            The access group you chose may have already been assigned to this application in another policy.
          </span>
        }
        @if (target === ConnectingTarget.Application) {
          <span>
            The application you chose may have already been assigned to this access group in another policy.
          </span>
        }
      </div>
    </div>
  }

  <div class="button-group button-group--center">
    <button type="button" class="btn btn-secondary btn-medium" [disabled]="busy" (click)="cancel()">
      Cancel
    </button>
    <button
      type="submit"
      class="btn btn-primary btn-medium"
      [class.btn-loading]="busy"
      [disabled]="form.invalid || busy"
    >
      Submit
    </button>
  </div>
</form>
